export const statusColorMap: { [key: string]: string } = {
  "0": "warning.main",
  "3": "success.main",
  "2": "error.main",
  "4": "#78909C",
  "1": "primary.main"
};
